import { UpdateProfileDto, User } from '@agently/types';
import { createMutation, createQuery } from 'react-query-kit';

import { api } from './client';

export const useUpdateAvatar = createMutation({
  mutationFn: ({ file }: { file: Blob | File }) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/profile', formData);
  },
});

export const useUpdateProfile = createMutation({
  mutationFn: ({ body }: { body: UpdateProfileDto }) =>
    api.put('/agent/profile', body),
});

export const useUpdateUser = createMutation({
  mutationFn: async (body: Partial<User>) => {
    const { data } = await api.put<User>('/agent/profile', body);
    return data;
  },
});

// Hook for getting user via /users endpoint (used in mobile app)
export const useGetUser = createQuery({
  fetcher: async () => {
    const { data } = await api.get<User>('/agent/profile');
    return data;
  },
  queryKey: ['user'],
});

export const useSendAppLink = createMutation({
  mutationFn: ({ body }: { body: { phone: string } }) =>
    api.post('/agent/send-app-link', body),
});
